import React, { useContext } from 'react';

import { MDText } from 'i18n-react';

import { formatPrice } from 'Utilities/formatPrice';

import LocalTexts from '../../../Payments.text.json';
import { PaymentContext } from '../../../PaymentsContext';

import styles from './NoFinanceApplicable.scss';

const LocalT = new MDText(LocalTexts.payments.figuresBox.noFinanceApplicable);

interface NoFinanceApplicableProps {
  reference?: string | null;
  text?: string;
}

const NoFinanceApplicable = ({ text }: NoFinanceApplicableProps) => {
  const { paymentState: { accountNumber, reference, sellerAmount } } = useContext(PaymentContext);

  return (
    <div className={styles.noFinanceApplicable}>
      <p>{LocalT.translate('title')}</p>
      {reference && (
        <p>
          <span className={styles.amount}>{reference}</span>
          {LocalT.translate('sellerReference')}
        </p>
      )}
      <p>
        <span className={styles.amount}>{formatPrice(sellerAmount)}</span>
        {' '}
        {text || LocalT.translate('text', { accountNumber })}
      </p>
    </div>
  );
};

export default NoFinanceApplicable;
